<template>
  <ul class="menu-nav">
    <template v-for="(item, i) in listItem">
      <router-link
        v-if="item.route"
        :key="i"
        :to="item.route"
        v-slot="{ href, navigate, isActive, isExactActive }"
        v-show="item.show"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && !item.submenu && 'menu-item-active',
            isExactActive && !item.submenu && 'menu-item-active',
            item.submenu && 'menu-item-submenu',
            getOpenMenu(item.submenu) && 'menu-item-open'
          ]"
          :key="`${i}-${item.id}`"
        >
          <a
            :href="href"
            class="menu-link"
            @click="navigate"
            v-bind:class="{
              'menu-toggle': item.submenu
            }"
          >
            <i :class="item.icon"></i>
            <span class="menu-text">{{ item.name }}</span>
            <i v-if="item.submenu" class="menu-arrow"></i>
          </a>
          <!-- RENDERING SUBMENU -->
          <div
            v-if="item.submenu"
            class="menu-submenu menu-submenu-classic menu-submenu-right"
          >
            <ul class="menu-subnav">
              <template v-for="(sub, index) in item.submenu">
                <!-- CẤP 3: chỉ dựng khi mục con có `submenu` của riêng nó.
                     Toàn bộ menu còn lại không có nhánh này nên render y như trước. -->
                <li
                  v-if="sub.submenu"
                  :key="`sub3-${index}`"
                  v-show="sub.show"
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                  class="menu-item menu-item-submenu"
                  :class="[getOpenMenu(sub.submenu) && 'menu-item-open']"
                >
                  <a href="javascript:;" class="menu-link menu-toggle">
                    <i :class="sub.icon"></i>
                    <span class="menu-text">{{ sub.name }}</span>
                    <i class="menu-arrow"></i>
                  </a>
                  <div class="menu-submenu">
                    <ul class="menu-subnav">
                      <template v-for="(leaf, leafIndex) in sub.submenu">
                        <router-link
                          v-if="leaf.route"
                          :key="`leaf-${index}-${leafIndex}`"
                          :to="leaf.route"
                          v-slot="{ href, navigate, isActive, isExactActive }"
                          v-show="leaf.show"
                        >
                          <li
                            aria-haspopup="true"
                            class="menu-item"
                            :class="[
                              isActive && 'menu-item-active',
                              isExactActive && 'menu-item-active'
                            ]"
                            :key="`leaf-li-${index}-${leafIndex}`"
                          >
                            <a :href="href" class="menu-link" @click="navigate">
                              <i :class="leaf.icon"></i>
                              <span class="menu-text">{{ leaf.name }}</span>
                            </a>
                          </li>
                        </router-link>
                      </template>
                    </ul>
                  </div>
                </li>
                <router-link
                  v-else-if="sub.route"
                  :key="`sub-${index}`"
                  :to="sub.route"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                  v-show="sub.show"
                >
                  <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[
                      isActive && 'menu-item-active',
                      isExactActive && 'menu-item-active'
                    ]"
                    :key="`sub-li-${index}`"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <i :class="sub.icon"></i>
                      <span class="menu-text">{{ sub.name }}</span>
                    </a>
                  </li>
                </router-link>
              </template>
            </ul>
          </div>
        </li>
      </router-link>
    </template>
  </ul>
</template>

<script>
import SavaDataUtil from '../../../utils/saveDataToLocal';
import _ from 'lodash';
export default {
  name: 'MenuItem',
  props: {
    listItem: Array
  },
  data() {
    return {
      listFeature: []
    };
  },
  created() {
    this.getListFeature();
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route['path'].indexOf(match) !== -1;
    },
    getListFeature() {
      this.listFeature = SavaDataUtil.getData('listFeature');
    },
    checkPermission(condition) {
      if (this.listFeature.indexOf(condition) > -1) {
        return true;
      } else {
        return false;
      }
    },
    getOpenMenu(submenu) {
      if (submenu) {
        const fullPath = this.$route.fullPath;
        const isMatch = _.find(submenu, item => {
          // Đệ quy xuống cấp 3: mục cha cấp 2 có `route: '#'` nên tự nó không bao giờ
          // khớp, phải dò tiếp vào con của nó thì cụm menu mới tự mở đúng trang.
          // Menu 2 cấp không có `item.submenu` -> nhánh này bỏ qua, kết quả giữ nguyên.
          return (
            _.startsWith(fullPath, item.route) || this.getOpenMenu(item.submenu)
          );
        });
        if (isMatch) {
          return true;
        }
      }
      return false;
    }
  }
};
</script>
